export default __webpack_public_path__ + "static/media/wild-swim.0f29d899.svg";